<script lang="ts">
	import { _ } from 'svelte-i18n';
	import Card from '@smui/card';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import FormLoading from '../../../..//shared/components/common/Loading/FormLoading.svelte';
	import Input from '@smui/textfield';
	import AzioneMonitoraggio from '../../../../shared/models/PSCL/Misura/AzioneMonitoraggio';

	export let params = {
		id: '0',
	};

	let [data, loading, error] = AzioneMonitoraggio.get(params.id);

	function onSubmit() {
		[data, loading, error] = AzioneMonitoraggio.save($data);
	}
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.monitoring_action.detail.title')}" />
		<div class="sm:flex-nowrap sm:space-x-4 flex flex-wrap">
			<button type="submit" form="form" class="btn-white h-14 w-14 sm:h-16 sm:w-16">
				<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
			</button>
		</div>
	</div>
	{#if $loading}
		<FormLoading />
	{:else}
		<form on:submit|preventDefault="{onSubmit}" id="form" class="md:grid-cols-3 grid grid-cols-1">
			<Input label="{$_('page.monitoring_action.detail.description')}" bind:value="{$data.descrizione}" required class="md:col-start-2" />
			<Input
				label="{$_('page.monitoring_action.detail.cost')}"
				bind:value="{$data.costo}"
				type="number"
				input$step="1"
				class="md:col-start-2"
			/>
			<Input label="{$_('page.monitoring_action.detail.note')}" bind:value="{$data.note}" class="md:col-start-2" />
		</form>
	{/if}
</Card>
